import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { HeaderData } from 'src/app/_models/header-data';

@Component({
  selector: 'app-no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss']
})
export class NoPermissionComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
  }

  setHeaderData(){
    this.headerData.pageTitle = "Permission Required";
    this.commonService.header = this.headerData;  
  }

}
